export default __webpack_public_path__ + "e0ca9bb1e68ff08dd7fa4accc99213ac.png";